import { useRender } from 'redity'
import buildNumberFormat from '../../../../../utilities/buildNumberFormat'
import { Keys } from '../../../constants'
import { storagePage } from '../../../storage'
import { TotalCostProps } from './types'

export default function TotalCost({
    logisticalDRs,
    logisticalCosts
}: TotalCostProps) {
    useRender(Keys.TOTAL_COST)
    const currentSymbol = storagePage.currentCurrency.symbol

    // Sumar el setting_local_cost de todos los costos con is_costing=true
    const settingLocalCostTotal = logisticalCosts
        .filter(cost => cost.logistical_concept?.is_costing === true)
        .reduce((a, b) => a + (b.setting_local_cost || 0), 0)

    // Calcular el monto a pagar: suma de logistical_cost de recepciones + setting_local_cost total
    const logisticalCostFromReceptions = logisticalDRs.reduce(
        (a, b) => a + b.logistical_cost - b.penalized_local_cost,
        0
    )
    const amoutPay = logisticalCostFromReceptions + settingLocalCostTotal
    const total =
        amoutPay + logisticalDRs.reduce((a, b) => a + b.purchase_local_cost, 0)

    return (
        <>
            <div className="flex justify-end mt-4 font-bold text-xs">
                <div className="bg-gray-200 py-2 px-10 col-span-2 w-56">
                    Costo TOTAL (Compra + Otros costos)
                </div>
                <div className="bg-gray-200 py-2 px-4 w-28">
                    {currentSymbol} {buildNumberFormat(total)}
                </div>
            </div>
            <div className="flex justify-end mt-4 font-bold text-xs">
                <div className="bg-gray-200 py-2 px-10 col-span-3 w-56">
                    Monto a Costear
                </div>
                <div className="bg-gray-200 py-2 px-4 w-28">
                    {currentSymbol} {buildNumberFormat(amoutPay)}
                </div>
            </div>
        </>
    )
}
